<template>
  <div class="send-exceptions">
    <div v-if="sendExceptions.total" class="controls-below-table pt-4 row">
      <div class="table-records-info col-lg-6 col-sm-12" v-if="sendExceptions.total">
        <p class="mb-0">
          <template v-if="sendExceptions.total == 1">
            {{sendExceptions.total}} {{ t('sendExceptionFoundLabel','sendExceptionFoundLabel') }}
          </template>
          <template v-else>
            {{sendExceptions.total}} {{ t('sendExceptionsFoundLabel','sendExceptionsFoundLabel') }}
          </template>
        </p>
      </div>
      <div class="col-lg-4 col-sm-12">
        <b-pagination v-if="sendExceptions.total" ref="paginationTop" class="float-right mb-0" v-model="page" :total-rows="sendExceptions.total" :per-page="perPage" aria-controls="batches-table">
        </b-pagination>
      </div>
      <div class="col-lg-2 col-sm-12 text-right">
        <b-input-group class="col-lg-12">
          <b-input-group-prepend>
            <label class="input-group-text">{{ t('paginationPerPage','paginationPerPage') }}</label>
          </b-input-group-prepend>
          <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
        </b-input-group>
      </div>
    </div>
    <b-table v-if="sendExceptions.sendExceptions" striped hover bordered responsive class="mt-3" style="overflow-x: auto;" :busy.sync="isBusy" :items="sendExceptions.sendExceptions" :fields="fields" no-sort-reset
    :total-rows="sendExceptions.total" per-page="0" :thead-class="'brand-color'" :tbody-tr-class="rowClass" show-empty>
      <template v-slot:head()="data">
        <span> {{ t('sendExceptions' + data.label, 'sendExceptions' + data.label) }}</span>
      </template>
      <template v-slot:head(customer_country)="data">
        <span> {{ t('sendExceptions' + data.label, 'sendExceptions' + data.label) }}</span>
      </template>
      <template class="busy-row" v-slot:table-busy>
        <vcl-table v-if="isLoading" :rows="perPage" :columns="columnsAmount"></vcl-table>
      </template>
      <template v-slot:empty="scope">
        <div class="text-center"> {{ t('noEntriesFound','noEntriesFound') }} </div>
      </template>
      <template v-slot:cell(timestamp)="data">
        {{data.item.timestamp}}
      </template>
      <template v-slot:cell(description)="data">
        <template v-if="data.item.description">
          {{ data.item.description }}
        </template>
        <template v-else>
          <span></span>
        </template>
      </template>
      <template v-slot:cell(id)="data">
        {{ data.item.id }}
      </template>
      <template v-slot:cell(document_value)="data">
         <template v-if="data.item.document_value && (data.item.document_value.value && data.item.document_value.exception_rule)">
          <template>
            <div :id="'tooltip_document_value_' + data.item.id">
              <span>{{ data.item.document_value.exception_rule }} {{ data.item.document_value.value.toString() | trimText(20) }}</span>
            </div>
            <b-tooltip ref="tooltip" :target="'tooltip_document_value_' + data.item.id">
              {{ data.item.document_value.exception_rule }} {{ data.item.document_value.value.toString() | trimText(20) }}
            </b-tooltip>
          </template>
        </template>
        <template v-else-if="data.item.document_value && data.item.document_value.value">
          {{ data.item.document_value.value.toString() | trimText(20) }}
        </template>
        <template v-else>
          {{t('all', 'all')}}
        </template>
      </template>
      <template v-slot:cell(duplicate_document)="data">
        <template v-if="data.item.duplicate_document && (data.item.duplicate_document.value && data.item.duplicate_document.exception_rule)">
          <template v-if="(data.item.duplicate_document.value == 'enabled') || (data.item.duplicate_document.value == 1)">
            {{ t('yes', 'yes') }}
          </template>
          <template v-else>
            {{ t('no', 'no') }}
          </template>
        </template>
        <template v-else>
          {{ t('no', 'no') }}
        </template>
      </template>
      <template v-slot:cell(rule)="data">
        <template v-if="data.item.rule_description && (data.item.rule_description.length > 1)">
          <div :id="'tooltip_rule_description_' + data.item.id">
            <span>{{ data.item.rule_description | trimText(20) }}</span>
          </div>
          <b-tooltip ref="tooltip" :target="'tooltip_rule_description_' + data.item.id">
            {{data.item.rule_description}}
          </b-tooltip>
        </template>
        <template v-else>
          -
        </template>
      </template>
      <template v-slot:cell(enabled)="data">
        <template v-if="data.item.enabled == 1">
          <fontAwesomeIcon  :icon="['fa', 'toggle-on']" class="text-success showhand" size="2x" @click="disableRule(data.item.id)"/>
        </template>
        <template v-else>
          <fontAwesomeIcon  :icon="['fa', 'toggle-on']" class="text-muted flip-icon showhand" size="2x" @click="enableRule(data.item.id)"/>
        </template>
      </template>
      <template v-slot:cell(actions)="data">
        <div style="display: flex;">
          <button class="btn btn-primary ml-2" @click="modalCreator({id: 'editRuleModalNew', title: t('editRuleModalHead','editRuleModalHead'), open: 'open'}, data.item, $event.target)"> {{t('editRule', 'editRule')}} </button>
          <!--<button class="btn btn-primary ml-2" @click="modalCreator({id: 'copyRuleModal', title: t('copyRuleModalHead','copyRuleModalHead'), open: 'open'}, {id: data.item.id}, $event.target)"> {{t('copyRule', 'copyRule')}} </button>-->
          <button class="btn btn-danger ml-2" @click="modalCreator({id: 'deleteRuleModal', title: t('deleteRuleModalHead','deleteRuleModalHead'), open: 'open'}, {id: data.item.id}, $event.target)"> {{t('deleteRule', 'deleteRule')}} </button>
        </div>
      </template>
      <template v-slot:cell()="data">
        <!-- NEWS-11060 -->
        <!-- Added new default/base cell handler for all custom attributes, PW -->
        <!-- Special: timestamp, id, description, rule, enabled, actions, document_value -->
        <!-- Yes/No fields have to be added to the exception array like duplicate_document -->
        <template v-if="!['timestamp', 'id', 'description', 'rule', 'enabled', 'actions', 'duplicate_document', 'document_value'].includes(data.field.key)">
          <template v-if="data.item[data.field.key + '_name'] && data.item[data.field.key + '_name'] != '' ">
            {{ data.item[data.field.key + '_name'] }}
          </template>
          <template v-else-if="data.item[data.field.key] && (data.item[data.field.key].value && data.item[data.field.key].exception_rule)">
            <template v-if="data.item[data.field.key].exception_rule == 'in_list' || data.item[data.field.key].exception_rule == 'not_in_list'">
              <template v-if="['customer_ref', 'document_ref'].includes(data.field.key)">
                <b-button variant="outline-primary" @click="getRulesValues({id: 'ruleInfoModal', title: t('ruleInfoModalHead','ruleInfoModalHead'), open: 'open', type: 'show', ruleType: data.item[data.field.key].exception_rule, ruleInfo: data.item[data.field.key].value, ruleException: data.item[data.field.key].exception_rule, data: data.field.key }, data.item[data.field.key], $event.target)">{{ t('infoText', 'infoText') }}</b-button>
              </template>
              <template v-else>
                <b-button variant="outline-primary" @click="getRulesValues({id: 'ruleInfoModal', title: t('ruleInfoModalHead','ruleInfoModalHead'), open: 'open', type: 'decode', ruleType: data.item[data.field.key].exception_rule, ruleInfo: data.item[data.field.key].value, ruleException: data.item[data.field.key].exception_rule, data: data.field.key }, data.item, $event.target)">{{ t('infoText', 'infoText') }}</b-button>
              </template>
            </template>
            <template v-else>
              <template v-if="data.item[data.field.key].value.includes('|')">
                <b-button variant="outline-primary" @click="getRulesValues({id: 'ruleInfoModal', title: t('ruleInfoModalHead','ruleInfoModalHead'), open: 'open', type: 'show', ruleType: data.item[data.field.key].exception_rule, ruleInfo: data.item[data.field.key].value, ruleException: data.item[data.field.key].exception_rule, data: data.field.key }, data.item[data.field.key], $event.target)">{{ t('infoText', 'infoText') }}</b-button>
              </template>
              <template v-else>
                <div :id="'tooltip_' + data.field.key + '_' + data.item.id">
                  <span>{{ data.item[data.field.key].value.toString() | trimText(20) }}</span>
                </div>
                <b-tooltip ref="tooltip" :target="'tooltip_' + data.field.key + '_' + data.item.id">
                  {{ data.item[data.field.key].value.toString() }}
                </b-tooltip>
              </template>
            </template>
          </template>
          <template v-else>
            {{t('notSet', 'notSet')}}
          </template>
        </template>
      </template>
    </b-table>

    <div v-if="sendExceptions.total" class="controls-below-table pt-4 row">
      <div class="table-records-info col-lg-6 col-sm-12" v-if="sendExceptions.total">
        <p class="mb-0">
          <template v-if="sendExceptions.total == 1">
            {{sendExceptions.total}} {{ t('sendExceptionFoundLabel','sendExceptionFoundLabel') }}
          </template>
          <template v-else>
            {{sendExceptions.total}} {{ t('sendExceptionsFoundLabel','sendExceptionsFoundLabel') }}
          </template>
        </p>
      </div>
      <div class="col-lg-4 col-sm-12">
        <b-pagination v-if="sendExceptions.total" ref="paginationBottom" class="float-right mb-0" v-model="page" :total-rows="sendExceptions.total" :per-page="perPage" aria-controls="batches-table">
        </b-pagination>
      </div>
      <div class="col-lg-2 col-sm-12 text-right">
        <b-input-group class="col-lg-12">
          <b-input-group-prepend>
            <label class="input-group-text">{{ t('paginationPerPage','paginationPerPage') }}</label>
          </b-input-group-prepend>
          <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
        </b-input-group>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import 'bootstrap-vue/dist/bootstrap-vue.css'
//import ResponseInfo from '@/components/ResponseInfo.vue'

export default {
  name: 'all_rules',
  inject: [
    'modalCreator',
    'refreshResults'
  ],
  data () {
    return {
      isBusy: false,
      perPage : 20,
      page: 1,
      pageOptions: [10, 20, 50, 100]
    }
  },
  computed:{
    ...mapGetters(['getResponseInfo', 'getSiteAppearanceSettings']),
    fields() {
      return this.$store.getters['sendExceptionsStore/getSendExceptionRulesColumns']
    },
    sendExceptions() {
      return this.$store.getters['sendExceptionsStore/getSendExceptions']
    }
  },
  watch: {
    page(newPage) {
      if(this.$route.query.page != newPage) {
        //this.refreshResults({pageNum: newPage})
        this.refreshResults({searchFrom: 'paginationNewPage', searchData: newPage})
      }
    },
    perPage(newPerPage) {
      if(this.$route.query.per_page != newPerPage) {
        //this.refreshResults({perPage: newPerPage})
        this.refreshResults({searchFrom: 'paginationPerPage', searchData: newPerPage})
      }
    }
  },
  methods:{
    checkForAll(value, key) {
      if(!(key == 'duplicate_document')) {
        if((value == null) || (value == undefined) || (!value) || (value == 0) || (value == '')) {
          return 'rule-all'
        }
      }
    },
    rowClass(item, type) {
      if(item && !item.enabled) {
        return 'inactive-rule'
      }
    },
    enableRule(ruleId) {
      this.$store.dispatch('sendExceptionsStore/enableSendException', ruleId)
      .then(() => {
          let response = this.getResponseInfo
          if(response.status == 'success') {
            this.refreshResults()
          }
          this.$parent.$refs['response'].scrollIntoView()
      })
    },
    disableRule(ruleId) {
      this.$store.dispatch('sendExceptionsStore/disableSendException', ruleId)
      .then(() => {
          let response = this.getResponseInfo
          if(response.status == 'success') {
            this.refreshResults()
          }
          this.$parent.$refs['response'].scrollIntoView()
      })
    },
    getRulesValues(modalData, ruleData, button) {
      // NEWS-11060 Based on the modal type we decide if we have to decode values from ids or just display them as they are in modal, PW
      if(modalData.type === 'show') {
        if(ruleData.value) {
          let values = new Array()
          let formattedValues = new Array()
          values = ruleData.value.split('|')

          values.forEach((el, index) => {
            formattedValues.push({
              'value_name': el
            })
          })

          let modalInfo = {
              id: 'ruleInfoModal', 
              title: this.$t('ruleInfoModalHead', 'ruleInfoModalHead'), 
              open: 'open', 
              ruleType: modalData.data,
              ruleException: modalData.ruleException, 
              ruleInfo: formattedValues }

            this.modalCreator(modalInfo, ruleData, button)
        }
      } else if(modalData.type === 'decode') {
        this.$store.dispatch('sendExceptionsStore/getExceptionRuleValues', modalData).then(response => {
          if(response.data_names) {
            let modalInfo = {
              id: 'ruleInfoModal', 
              title: this.$t('ruleInfoModalHead', 'ruleInfoModalHead'), 
              open: 'open', 
              ruleType: modalData.data,
              ruleException: modalData.ruleException,  
              ruleInfo: response.data_names }

            this.modalCreator(modalInfo, ruleData, button)
          }
        })
      }
    },
  },
  created() {
    this.$store.dispatch('sendExceptionsStore/getSendExceptionRulesColumns')
    if(Object.keys(this.$route.query).length) {
      if(this.$route.query.per_page) {
        if(!this.pageOptions.includes(Number(this.$route.query.per_page))) {
          this.pageOptions.push(this.$route.query.per_page)
        }
        this.perPage = this.$route.query.per_page
      }
      if(this.$route.query.page) {
        this.page = this.$route.query.page
      }
    }
  },
  filters:{
    trimText: function(text, length) {
      let textFormatted = text
      if(textFormatted.length > length) {
        textFormatted = text.slice(0, length)
        textFormatted += '...'
      }
      return textFormatted
    }
  },
  components:{
    //ResponseInfo
  }
}
</script>

<style scoped>
  .showhand{
    cursor: pointer;
  }
  /*TABLE*/
  .table-responsive  >>> .brand-color {
    background-color: #047bf8 !important;
    color: white !important;
  }
  .table-responsive  >>> td.highlight-blue{
    background-color: #bee5eb !important;
  }
  .table-responsive  >>> td.highlight-red{
    background-color: #f1b0b7 !important;
  }

  .table-responsive >>> .inactive-rule{
    color: #9E9E9E !important;
  }
  .table-responsive >>> .rule-all{
    background-color: #EEEEEE;
  }

  /* this is for flipping the toggle button icon, as this variant is not available in the font library*/
  .flip-icon{
    -webkit-transform: scaleX(-1);
    transform: scaleX(-1);
  }
</style>
